// ===================================================================
// KAIXO - Helpers de acceso a features según plan + accountType
// ===================================================================
// Centralizamos las reglas de "qué pestañas / módulos ve el usuario"
// para no repetir la lógica en múltiples componentes ni desincronizarla.
// ===================================================================

/**
 * Impulsa (CRM / publicidad propia) — solo accesible para cuentas
 * business con plan PAGADO. Una cuenta business en plan FREE NO ve
 * la pestaña, debe upgradar primero.
 *
 * Tiers que dan acceso: STARTER, GROWTH, PRO, SCALE.
 * FREE o sin tier definido → sin acceso aunque sea business.
 */
const PAID_TIERS = new Set(['STARTER', 'GROWTH', 'PRO', 'SCALE']);

export function hasImpulsaAccess(user) {
    if (!user) return false;
    if (user.accountType !== 'business') return false;
    const tier = user.planTier || user.plan;
    if (!tier) return false;
    return PAID_TIERS.has(tier);
}

/**
 * CRM avanzado (idéntico que Impulsa por ahora). Lo separamos por
 * si en el futuro se desacopla.
 */
export function hasCrmAccess(user) {
    return hasImpulsaAccess(user);
}
